import React from 'react';
import PropTypes from 'prop-types';
import Select from '../forms/inputs/Select';
import translate from '../translate';

function BasicPortletWithFilters({
  title,
  subtitle,
  children,
  titleClass,
  filters,
  dropdownItems,
  dropdownItemActive,
  onChangeDropdown,
  dropdownId,
  customDropdown,
  customFiltersChildren,
}) {
  return (
    <div className="m-portlet m-portlet--mobile">
      <div className="m-portlet__head">
        <div className="m-portlet__head-caption">
          <div className="m-portlet__head-title">
            <h3
              className={`m-portlet__head-text ${titleClass || ''}`}
              style={{ color: 'var(--dynamic)' }}
            >
              {title}
              {subtitle && <small>{subtitle}</small>}
            </h3>
          </div>
        </div>
        {!customDropdown ? (
          <div className="m-portlet__head-tools">
            {filters.length > 0 &&
              filters.map(f => (
                <button
                  key={f.toolTitle}
                  type="button"
                  onClick={f.toolFilter}
                  className={f.toolClass}
                >
                  {f.toolTitle}
                </button>
              ))}
            {dropdownItems.length > 0 && (
              <div className="select-container">
                <Select
                  id={dropdownId}
                  items={dropdownItems}
                  value={dropdownItemActive}
                  onChange={onChangeDropdown}
                  searchable={false}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="m-portlet__head-tools">{customFiltersChildren}</div>
        )}
      </div>
      <div className="m-portlet__body">{children}</div>
    </div>
  );
}

BasicPortletWithFilters.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  customFiltersChildren: PropTypes.node,
  titleClass: PropTypes.string,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      toolAnchor: PropTypes.string,
      toolTitle: PropTypes.string,
      toolClass: PropTypes.string,
    }),
  ),
  dropdownItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
  dropdownItemActive: PropTypes.string,
  onChangeDropdown: PropTypes.func,
  dropdownId: PropTypes.string,
  customDropdown: PropTypes.bool,
};

BasicPortletWithFilters.defaultProps = {
  subtitle: null,
  titleClass: null,
  filters: [],
  dropdownItems: [],
  dropdownItemActive: '',
  onChangeDropdown: () => {},
  dropdownId: '',
  customFiltersChildren: null,
  customDropdown: false,
};

export default translate(BasicPortletWithFilters);
